// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';
import {fetch} from 'wix-fetch';
import {session} from 'wix-storage';
import parser from 'fast-xml-parser';
import { getCurrentCart } from 'backend/delivery';
import { cart } from 'wix-stores';

async function setCartId () {
	const cart = await getCurrentCart();
	console.log(cart, 'cart data');
	const newEpostRecord = {
		cartId: cart._id,
	};
	wixData.query('epostOrders')
		.eq('cartId', cart._id)
		.find()
		.then(res => {
			if (res.items.length === 0) {
				wixData.insert('epostOrders', newEpostRecord)
					.then(newEpostRes => {
						console.log(newEpostRes, 'new epost record');
						return true;
					})
					.catch(e => {
						console.log(e, 'new epost record error');
						return false;
					});
			} else {
				console.log('record with this cart ID exist');
			}
		})
		.catch(e => console.log(e, 'get existing records with cart id error'));
}

$w.onReady(function () {
	setCartId();
	
	const cities = [];
	fetch('https://data.gov.il/api/3/action/datastore_search?resource_id=5c78e9fa-c2e2-4771-93ff-7f400a12f7ba&limit=1273', {
		method: 'GET',
	})
		.then(res => res.json())
		.then(res => {
			res.result.records.sort((a, b) => {
				if (a['שם_ישוב'] < b['שם_ישוב']) return -1;
				if (a['שם_ישוב'] > b['שם_ישוב']) return 1;
				return 0;
			}).forEach(city => cities.push({label: city['שם_ישוב'], value: city['שם_ישוב']}));
			$w('#dropdown2').options = cities;
		})
		.catch(e => console.log(e));	

	const points = [];
	let chosenPoint;
	$w('#dropdown2').onChange(event => {
		console.log($w('#dropdown1').value);
		if($w('#dropdown1').value) 
			$w('#text33').text = 'נקודה נמחקה. אנא בחר נקודה חדשה';
		
		$w('#dropdown1').options = [{value: '0', label: 'אנא המתן...'}];
		fetch(`https://run.hfd.co.il/RunCom.Server/Request.aspx?APPNAME=run&PRGNAME=ws_spotslist&ARGUMENTS=-A${event.target.value}`, {
			method: 'GET',
		})
			.then(res => res.text())
			.then(res => {
				const xmlRes = parser.parse(res);
				const postPoints = [];
				if (Array.isArray(xmlRes.root.spots.spot_detail)) {
					xmlRes.root.spots.spot_detail.forEach(point => {
						points.push(point);
						postPoints.push({value: point.n_code, label: `${point.name}: רח' ${point.street} ${point.house}`});
					})
				} else {
					points.push(xmlRes.root.spots.spot_detail);
					postPoints.push({value: xmlRes.root.spots.spot_detail.n_code, label: `${xmlRes.root.spots.spot_detail.name}: רח' ${xmlRes.root.spots.spot_detail.street} ${xmlRes.root.spots.spot_detail.house}`});
					chosenPoint = points[0];
					const chosenPointText = `<p dir="rtl">נקודת האיסוף שבחרת:<br />
					${chosenPoint.street} ${chosenPoint.house} ${chosenPoint.city}<br />
					${chosenPoint.type}<br />
					${chosenPoint.remarks}</p>`;
					$w('#text33').html = chosenPointText;
				}
				console.log(postPoints);
				$w('#dropdown1').options = postPoints;
				$w('#dropdown1').value = '';
			})
			.catch(e => console.log(e));
	})

	$w('#dropdown1').onChange(async event => {
		if (event.target.value) {
			const cart = await getCurrentCart();
			let chosenPointInfo = '';
			wixData.query('epostOrders')
				.eq('cartId', cart._id)
				.find()
				.then(res => {
					console.log(res, 'existing epost records by epostId');
					const pointCode = res.items.length === 1 ? event.target.value : '';
					console.log(pointCode, 'chosen point code');
					if (pointCode) {
						chosenPoint = points.filter(point => point.n_code === event.target.value);
						const chosenPointText = `<p dir="rtl">נקודת האיסוף שבחרת:<br />
							${chosenPoint[0].street} ${chosenPoint[0].house} ${chosenPoint[0].city}<br />
							${chosenPoint[0].type}<br />
							${chosenPoint[0].remarks}</p>`;
						$w('#text33').html = chosenPointText;
						chosenPointInfo = `${chosenPoint[0].street} ${chosenPoint[0].house} ${chosenPoint[0].city}
							${chosenPoint[0].type}
							${chosenPoint[0].remarks}`;
					} else {
						$w('#text33').html = '';
					}
					$w('#text33').show();
					if (res.items.length === 1) {
						const updateEpostOrder = {
							_id: res.items[0]._id,
							cartId: res.items[0].cartId,
							pointCode,
							pointInfo: chosenPointInfo,
						};
						wixData.update('epostOrders', updateEpostOrder)
							.then(updatedEpostItem => console.log(updatedEpostItem, 'update epost recored'))
							.catch(e => console.log(e, 'updating epost record error'));
					}
					console.log(pointCode, 'point code');
				})
				.catch(e => console.log(e, 'retreiving epost record by epostid error'));
		}
	});
});